import { useContext } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { apiGet, apiPatch } from 'api'
import AuthContext from 'context/auth-context'

// Per-user datum report assignments (tag-based vs direct one-off grants) for
// municipal user admins.

const getUserReports = async (token, userId) =>
  apiGet({ url: `municipality_admin/users/${userId}/reports`, token })

const updateUserReports = async (token, userId, params) =>
  apiPatch({ url: `municipality_admin/users/${userId}/reports`, token, objectName: 'datum_user_report', params })

export const useMunicipalityAdminUserReports = ({ userId, options } = {}) => {
  const token = useContext(AuthContext)
  return useQuery(
    ['municipality-admin-user-reports', userId],
    () => getUserReports(token, userId),
    { enabled: !!userId, ...options }
  )
}

export const useUpdateMunicipalityAdminUserReports = ({ userId, options } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (params) => updateUserReports(token, userId, params),
    {
      ...options,
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['municipality-admin-user-reports', userId])
        queryClient.invalidateQueries(['municipality-admin-users'])
        options?.onSuccess?.(data, variables)
      }
    }
  )
}
